import { render, staticRenderFns } from "./text-input.vue?vue&type=template&id=2ef7ddbb&scoped=true&"
import script from "./text-input.vue?vue&type=script&lang=ts&"
export * from "./text-input.vue?vue&type=script&lang=ts&"
import style0 from "./text-input.vue?vue&type=style&index=0&id=2ef7ddbb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef7ddbb",
  null
  
)

export default component.exports